const hostArray = (window.location.host || '').split('.');
const subjectDomain = hostArray[hostArray.length - 2];
console.log(hostArray, 'hostArray');
const HOST_URL_MAP = {
  yxtechai: 'ww026189ab05972f25'
};
// 环境变量配置
export const ENV_CONFIG = {
  // 外部用户ID
  EXTERNAL_USER_ID: import.meta.env.VITE_EXTERNAL_USER_ID || 'wmICnAGQAAfl4s-uJVmuf6oTMZ6WGE1Q',

  // API 配置
  API_BASE_URL:
    import.meta.env.VITE_API_BASE_URL || 'https://oceanus-outbound-copilot.100credit.com',
  MERCHANT_ID: import.meta.env.VITE_MERCHANT_ID || '2025070802',

  // 企业微信配置
  WECOM_CORP_ID: HOST_URL_MAP[subjectDomain || 'yxtechai'] || 'ww026189ab05972f25',
  WECOM_AGENT_ID: '1000012',

  // 环境类型
  NODE_ENV: import.meta.env.MODE || 'development',
  IS_DEV: import.meta.env.DEV || import.meta.env.MODE === 'development',
  IS_PROD: import.meta.env.PROD,

  // 调试配置
  ENABLE_VCONSOLE:
    import.meta.env.VITE_ENABLE_VCONSOLE === 'true' ||
    import.meta.env.DEV ||
    import.meta.env.MODE === 'development',

  HOST_URL_MAP
} as const;

// 导出单个配置项，方便使用
export const {
  EXTERNAL_USER_ID,
  API_BASE_URL,
  MERCHANT_ID,
  WECOM_CORP_ID,
  WECOM_AGENT_ID,
  IS_DEV,
  ENABLE_VCONSOLE
} = ENV_CONFIG;
